export enum GeneralActCargoTypeCodes {
    containers = 'CONT',
    bulk = 'BULK',
    roro = 'RORO'
}
